import axios from 'axios'

export default {
  // 최초 접속 시 보여질 메뉴목록 호출
  getMenuList (cb) {
    axios.get('/biz/index/basic_menu/')
      .then(function (response) {
        // 정상적으로 불러온 경우에는
        if (response.status === 200) {
          if (response.data.error) {
            cb(response.data)
          } else {
            cb(response.data)
          }
        } else {
          console.log('fail get MenuList!', response)
        }
      })
      .catch(function (response) {
        response.error = true
        cb(response)
      })
  },

  // SMP, REC 가격정보 불러오기
  getPriceInfo (cb) {
    axios.get('/biz/index/recsmp/')
      .then(function (response) {
        // 정상적으로 불러온 경우에는
        if (response.status === 200) {
          if (response.data.error) {
            cb(response.data)
          } else {
            cb(response.data)
          }
        } else {
          console.log('fail get SMPRECInfo!')
        }
      })
      .catch(function (response) {
        response.error = true
        cb(response)
      })
  },

  // 배너 불러오기
  getBanner (category = '', cb) {
    axios.get(`/biz/bizcommon/banner/?category=${category}`)
      .then(function (response) {
        // 정상적으로 불러온 경우에는
        if (response.status === 200) {
          if (response.data.error) {
            cb(response.data)
          } else {
            cb(response.data)
          }
        } else {
          console.log('fail get Banner list!')
        }
      })
      .catch(function (response) {
        response.error = true
        cb(response)
      })
  },

  // 제휴문의
  ContactUs (data, cb) {
    axios.post('/biz/inquery/', data)
      .then(function (response) {
        // 정상적으로 데이터 전송한 경우에는
        if (response.status === 201) {
          if (response.data.error) {
            cb(response.data)
          } else {
            cb(response.data)
          }
        } else {
          console.log('can`t next step!')
        }
      })
      .catch(function (response) {
        response.error = true
        cb(response)
      })
  },

  // 공지사항을 가져오는 api
  getNotice (query = '', cb) {
    const baseUrl = '/biz/notice/'
    const requestUrl = baseUrl + query

    axios.get(requestUrl)
      .then(function (response) {
        // 정상적으로 불러온 경우에는
        if (response.status === 200) {
          if (response.data.error) {
            cb(response.data)
          } else {
            cb(response.data)
          }
        } else {
          console.log('fail get Notice!', response)
        }
      })
      .catch(function (response) {
        response.error = true
        cb(response)
      })
  },

  // 자주묻는 질문을 가져오는 API
  getFaq (query = '', cb) {
    const baseUrl = '/biz/faq/'
    const requestUrl = baseUrl + query

    axios.get(requestUrl)
      .then(function (response) {
        // 정상적으로 불러온 경우에는
        if (response.status === 200) {
          if (response.data.error) {
            cb(response.data)
          } else {
            cb(response.data)
          }
        } else {
          console.log('fail get Faq!', response)
        }
      })
      .catch(function (response) {
        response.error = true
        cb(response)
      })
  },

  // 지도정보
  getMapInfo (data, cb) {
    axios.get('/biz/review/land/mapInfo/?address=' + data, {
      params: {
        format: 'json'
      }
    })
      .then(function (response) {
        // 정상적으로 불러온 경우에는
        if (response.status === 200) {
          if (response.data.error) {
            cb(response.data)
          } else {
            cb(response.data)
          }
        } else {
          console.log('fail get mapInfo!')
        }
      })
      .catch(function (response) {
        response.error = true
        cb(response)
      })
  },

  // 토지정보
  getLandInfo (data, cb) {
    axios.get('/biz/review/land/landInfo/?address=' + data, {
      params: {
        format: 'json'
      }
    })
      .then(function (response) {
        // 정상적으로 불러온 경우에는
        if (response.status === 200) {
          if (response.data.error) {
            cb(response.data)
          } else {
            cb(response.data)
          }
        } else {
          console.log('fail get landinfo!')
        }
      })
      .catch(function (response) {
        response.error = true
        cb(response)
      })
  },

  // 행위제한
  getRestrictInfo (data, cb) {
    axios.get('/biz/review/land/landRestrictInfo/?address=' + data, {
      params: {
        format: 'json'
      }
    })
      .then(function (response) {
        // 정상적으로 불러온 경우에는
        if (response.status === 200) {
          if (response.data.error) {
            cb(response.data)
          } else {
            cb(response.data)
          }
        } else {
          console.log('fail get landRestrictInfo!')
        }
      })
      .catch(function (response) {
        response.error = true
        cb(response)
      })
  },

  // 조례정보
  getExamineInfo (data, cb) {
    axios.get('/biz/review/land/examineInfo/?address=' + data, {
      params: {
        format: 'json'
      }
    })
      .then(function (response) {
        // 정상적으로 불러온 경우에는
        if (response.status === 200) {
          if (response.data.error) {
            cb(response.data)
          } else {
            cb(response.data)
          }
        } else {
          console.log('fail get examineInfo!')
        }
      })
      .catch(function (response) {
        response.error = true
        cb(response)
      })
  },

  // 건물정보
  getArchInfo (data, cb) {
    axios.get('/biz/review/land/archInfo/?address=' + data, {
      params: {
        format: 'json'
      }
    })
      .then(function (response) {
        // 정상적으로 불러온 경우에는
        if (response.status === 200) {
          if (response.data.error) {
            cb(response.data)
          } else {
            cb(response.data)
          }
        } else {
          console.log('fail get archInfo!')
        }
      })
      .catch(function (response) {
        response.error = true
        cb(response)
      })
  },

  // 전력계통정보
  getElectronicInfo (data, cb) {
    axios.get('/biz/review/land/basicElectronicInfo/?address=' + data, {
      params: {
        format: 'json'
      }
    })
      .then(function (response) {
        // 정상적으로 불러온 경우에는
        if (response.status === 200) {
          if (response.data.error) {
            cb(response.data)
          } else {
            cb(response.data)
          }
        } else {
          console.log('fail get basicElectronicInfo!')
        }
      })
      .catch(function (response) {
        response.error = true
        cb(response)
      })
  },

  // 인접지번정보
  getJibunList (data, cb) {
    axios.get('/biz/review/land/electronicJibunMaster/?address=' + data, {
      params: {
        format: 'json'
      }
    })
      .then(function (response) {
        // 정상적으로 불러온 경우에는
        if (response.status === 200) {
          if (response.data.error) {
            cb(response.data)
          } else {
            cb(response.data)
          }
        } else {
          console.log('fail get JibunList!')
        }
      })
      .catch(function (response) {
        response.error = true
        cb(response)
      })
  },

  // 전화번호정보
  getPhoneInfo (data, cb) {
    axios.get('/biz/review/land/phoneInfo/?address=' + data, {
      params: {
        format: 'json'
      }
    })
      .then(function (response) {
        // 정상적으로 불러온 경우에는
        if (response.status === 200) {
          if (response.data.error) {
            cb(response.data)
          } else {
            cb(response.data)
          }
        } else {
          console.log('fail get phoneInfo!')
        }
      })
      .catch(function (response) {
        response.error = true
        cb(response)
      })
  },

  // 발전량 시뮬레이션
  getSimulator (data, cb) {
    // url Set
    const anomaly = axios.create({
      baseURL: 'https://api.haezoom.io',
      'Access-Control-Allow-Origin': '*',
      xhrFields: {
        withCredentials: true
      },
      crossDomain: true
    })

    anomaly.defaults.headers.common['Authorization'] = 'Token a4b71148f351b53425d6bf139fc2777db6eb9a93'

    const url = '/v1/typicalyear/simulate/?lat=' + data.latlng.lat + '&lng=' + data.latlng.lng +
      '&aspect=' + data.aspect + '&angle=' + data.tilt_angle +
      '&shutdown_day=' + data.suspension_date_cnt + '&shade=' + data.shade_lose
    // 발전량 시뮬레이션 실행
    anomaly.get(url)
      .then(function (response) {
        // 정상적으로 불러온 경우에는
        if (response.status === 200) {
          cb(response.data)
        } else if (response.status === 201) {
          cb(response.data)
        } else {
          console.log('get simulator fail')
        }
      })
      .catch(function (response) {
        response.error = true
        cb(response)
      })
  },

  // 평균온도
  getTemperature (data, cb) {
    // url Set
    const anomaly = axios.create({
      baseURL: 'https://api.haezoom.io',
      'Access-Control-Allow-Origin': '*',
      xhrFields: {
        withCredentials: true
      },
      crossDomain: true
    })

    anomaly.defaults.headers.common['Authorization'] = 'Token a4b71148f351b53425d6bf139fc2777db6eb9a93'

    const url = '/v1/typicalyear/temperature/?lat=' + data.latlng.lat + '&lng=' + data.latlng.lng

    // 온도 정보 불러오기
    anomaly.get(url)
      .then(function (response) {
        // 정상적으로 불러온 경우에는
        if (response.status === 200) {
          cb(response.data)
        } else if (response.status === 201) {
          cb(response.data)
        } else {
          console.log('get temperature fail')
        }
      })
      .catch(function (response) {
        response.error = true
        cb(response)
      })
  },

  // 평균일사량
  getYearIrradiance (data, cb) {
    // url Set
    const anomaly = axios.create({
      baseURL: 'https://api.haezoom.io',
      'Access-Control-Allow-Origin': '*',
      xhrFields: {
        withCredentials: true
      },
      crossDomain: true
    })

    anomaly.defaults.headers.common['Authorization'] = 'Token a4b71148f351b53425d6bf139fc2777db6eb9a93'

    const url = '/v1/typicalyear/irradiance/?lat=' + data.latlng.lat + '&lng=' + data.latlng.lng + '&var=yearly'

    // 일사량 정보 불러오기
    anomaly.get(url)
      .then(function (response) {
        // 정상적으로 불러온 경우에는
        if (response.status === 200) {
          cb(response.data)
        } else if (response.status === 201) {
          cb(response.data)
        } else {
          console.log('get daily-irradiance fail')
        }
      })
      .catch(function (response) {
        response.error = true
        cb(response)
      })
  },

  // 보고서 기본값 불러오기
  getUserCondition (cb) {
    axios.get('/biz/review/condition/')
      .then(function (response) {
        // 정상적으로 불러온 경우에는
        if (response.status === 200) {
          if (response.data.error) {
            cb(response.data)
          } else {
            cb(response.data)
          }
        } else {
          console.log('fail get Condition!')
        }
      })
      .catch(function (response) {
        response.error = true
        cb(response)
      })
  },

  // 보고서 기본값 저장하기
  saveCondition (data, cb) {
    if (typeof data.id === 'undefined') {
      let url = '/biz/review/condition/?type=' + data['type']
      if (data.section) {
        url += '&section=' + data.section
      }
      axios.post(url, data)
        .then(function (response) {
          // 정상적으로 불러온 경우에는
          if (response.status === 200) {
            if (response.data.error) {
              cb(response.data)
            } else {
              cb(response.data)
            }
          } else {
            console.log('fail save condition!')
          }
        })
        .catch(function (response) {
          response.error = true
          cb(response)
        })
    } else {
      let url = '/biz/review/condition/' + data.id + '/' + data.type
      if (data.section) {
        url += '&section=' + data.section
      }
      axios.put(url, data)
        .then(function (response) {
          // 정상적으로 불러온 경우에는
          if (response.status === 200) {
            if (response.data.error) {
              cb(response.data)
            } else {
              cb(response.data)
            }
          } else {
            console.log('fail modify condition!')
          }
        })
        .catch(function (response) {
          response.error = true
          cb(response)
        })
    }
  },

  // 수익계산
  getProfitInfo (type, data, cb) {
    axios.post('/biz/review/profit/calculate/?type=' + type, data)
      .then(function (response) {
        // 정상적으로 불러온 경우에는
        if (response.status === 200) {
          if (response.data.error) {
            cb(response.data)
          } else {
            cb(response.data)
          }
        } else {
          console.log('fail get basicElectronicInfo!')
        }
      })
      .catch(function (response) {
        response.error = true
        cb(response)
      })
  },

  // 발전분석정보
  getAnalysisInfo (data, cb) {
    const url = '/biz/review/profit/analysis/' + '?aspect=' + data.aspect + '&tilt_angle=' + data.tilt_angle +
      '&shade_lose=' + data.shade_lose + '&suspension_date_cnt=' + data.suspension_date_cnt + '&address=' + data.address
    axios.get(url)
      .then(function (response) {
        // 정상적으로 불러온 경우에는
        if (response.status === 200) {
          if (response.data.error) {
            cb(response.data)
          } else {
            cb(response.data)
          }
        } else {
          console.log('fail get Analysis!')
        }
      })
      .catch(function (response) {
        response.error = true
        cb(response)
      })
  },

  // REC 가중치 불러오기
  getRecWeight (data, cb) {
    axios.get('/biz/review/profit/recweight/?plant_type=' + data.plant_type + '&expect_capacity=' + data.expect_capacity)
      .then(function (response) {
        // 정상적으로 불러온 경우에는
        if (response.status === 200) {
          if (response.data.error) {
            cb(response.data)
          } else {
            cb(response.data)
          }
        } else {
          console.log('fail get RectWeight!')
        }
      })
      .catch(function (response) {
        response.error = true
        cb(response)
      })
  },

  // 보고서 불러오기
  getReport (type, id, cb) {
    const url = type === 'S' ? '/biz/review/list/' : '/biz/review/exlist/'
    axios.get(url + id + '/')
      .then(function (response) {
        // 정상적으로 불러온 경우에는
        if (response.status === 200) {
          if (response.data.error) {
            cb(response.data)
          } else {
            cb(response.data)
          }
        } else {
          console.log('fail get Report!')
        }
      })
      .catch(function (response) {
        response.error = true
        cb(response)
      })
  },

  // 보고서 저장하기
  saveReport (type, data, cb) {
    const url = type === 'S' ? '/biz/review/list/' : '/biz/review/exlist/'
    if (typeof data.id === 'undefined') {
      axios.post(url, data)
        .then(function (response) {
          // 정상적으로 불러온 경우에는
          if (response.status === 200) {
            if (response.data.error) {
              cb(response.data)
            } else {
              cb(response.data)
            }
          } else {
            console.log('fail save report!')
          }
        })
        .catch(function (response) {
          response.error = true
          cb(response)
        })
    } else {
      axios.put(url + data.id + '/', data)
        .then(function (response) {
          // 정상적으로 불러온 경우에는
          if (response.status === 200) {
            if (response.data.error) {
              cb(response.data)
            } else {
              cb(response.data)
            }
          } else {
            console.log('fail modify report!')
          }
        })
        .catch(function (response) {
          response.error = true
          cb(response)
        })
    }
  },

  // 보고서 삭제하기
  removeReport (data, cb) {
    axios.delete('/biz/review/list/' + data + '/')
      .then(function (response) {
        // 정상적으로 불러온 경우에는
        if (response.status === 200) {
          if (response.data.error) {
            cb(response.data)
          } else {
            cb(response.data)
          }
        } else {
          console.log('fail remove report!')
        }
      })
      .catch(function (response) {
        response.error = true
        cb(response)
      })
  },
  // 전력분석보고서
  // 보고서 불러오기
  getEpaReport (type, id, cb) {
    const url = '/biz/electric-power-analysis/'
    axios.get(url + id + '/')
      .then(function (response) {
        // 정상적으로 불러온 경우에는
        if (response.status === 200) {
          if (response.data.error) {
            cb(response.data)
          } else {
            cb(response.data)
          }
        } else {
          console.log('fail get Report!')
        }
      })
      .catch(function (response) {
        response.error = true
        cb(response)
      })
  },
  // 보고서 저장하기
  saveEpaReport (data, cb) {
    const url = '/biz/electric-power-analysis/'
    if (typeof data.id === 'undefined') {
      axios.post(url, data)
        .then(function (response) {
          // 정상적으로 불러온 경우에는
          if (response.status === 200 || response.status === 201) {
            if (response.data.error) {
              cb(response.data)
            } else {
              cb(response.data)
            }
          } else {
            console.log('fail save report!')
          }
        })
        .catch(function (response) {
          response.error = true
          cb(response)
        })
    } else {
      axios.put(url + data.id + '/', data)
        .then(function (response) {
          // 정상적으로 불러온 경우에는
          if (response.status === 200) {
            if (response.data.error) {
              cb(response.data)
            } else {
              cb(response.data)
            }
          } else {
            console.log('fail modify report!')
          }
        })
        .catch(function (response) {
          response.error = true
          cb(response)
        })
    }
  },
  // 보고서 삭제하기
  removeEpaReport (data, cb) {
    axios.delete('/biz/electric-power-analysis/' + data + '/')
      .then(function (response) {
        // 정상적으로 불러온 경우에는
        if (response.status === 200 || response.status === 204) {
          if (response.data.error) {
            cb(response.data)
          } else {
            cb(response.data)
          }
        } else {
          console.log('fail remove report!')
        }
      })
      .catch(function (response) {
        response.error = true
        cb(response)
      })
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js